module.exports = require("bee-table/build/lib/singleSelect");